import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { useT } from "@/i18n/LanguageContext";
import { toast } from "sonner";

export default function DistributorLogin() {
  const { login, user } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (user?.role === "distributor") nav("/distributors/portal", { replace: true });
    else if (user?.role === "admin") nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role !== "distributor") { toast.error(t("dist.useAdminLogin")); return; }
      nav("/distributors/portal", { replace: true });
    } catch (err) { toast.error(err.message || t("dist.loginFailed")); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen bg-[#F7F5EE] text-[#0F1A12] overflow-hidden flex items-center justify-center p-6" data-testid="distributor-login">
      <img
        aria-hidden
        src="/hupla-emblem.svg"
        alt=""
        className="pointer-events-none select-none absolute -right-40 -bottom-40 w-[720px] max-w-none opacity-[0.06]"
      />
      <button
        type="button"
        onClick={() => nav("/")}
        aria-label={t("dist.closeAria") || "Close"}
        data-testid="dist-login-close"
        className="absolute top-5 right-5 z-10 inline-flex items-center justify-center w-11 h-11 rounded-full bg-white shadow-sm hover:bg-black/5 text-black/70 border border-black/10 transition-colors"
      >
        <X className="w-5 h-5" />
      </button>
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-sm p-8 border border-black/5">
        <p className="text-[0.7rem] font-bold uppercase tracking-[0.36em] text-[#B02224] mb-3">{t("dist.portalOverline")}</p>
        <h1 className="font-editorial italic text-3xl mb-6">{t("dist.signInTitle")}</h1>
        <form onSubmit={submit} className="space-y-3">
          <input required type="email" placeholder={t("dist.emailPh")} value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-lg border border-black/15 px-3 py-2.5 text-sm" data-testid="dist-login-email" />
          <input required type="password" placeholder={t("dist.passwordPh")} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-lg border border-black/15 px-3 py-2.5 text-sm" data-testid="dist-login-password" />
          <button type="submit" disabled={busy} className="w-full rounded-full bg-[#0F1A12] text-white py-2.5 text-sm font-semibold disabled:opacity-60" data-testid="dist-login-submit">
            {busy ? t("dist.signingIn") : t("dist.signInBtn")}
          </button>
        </form>
        <p className="mt-6 text-xs text-black/60">
          {t("dist.newDist")} <Link to="/distributors/register" className="underline hover:text-black" data-testid="dist-login-to-register">{t("dist.registerLink")}</Link>
        </p>
      </div>
    </div>
  );
}
